import { lazy, Suspense } from "react";
import { createBrowserRouter, Navigate, Outlet, useLocation } from "react-router-dom";
import App from '../App';
import Home from "../Components/Home";

const Login = lazy(() => import("../Components/auth/login/Login"));
const Signup = lazy(() => import("../Components/auth/SignUp/Signup"));
const Token = lazy(() => import("../Components/ProtectedRouteSection/token/Token"));
const Kyc = lazy(() => import("../Components/ProtectedRouteSection/kyc/Kyc"));
const Manuwalkyc = lazy(() => import("../Components/ProtectedRouteSection/kyc/Manuwalkyc"));
const SumsubKyc = lazy(() => import("../Components/ProtectedRouteSection/kyc/SumsubKyc"));
const Profile = lazy(() => import("../Components/ProtectedRouteSection/profile/Profile"));
const Deposit = lazy(() => import("../Components/ProtectedRouteSection/deposit/Deposit"));
const MyTokens = lazy(() => import("../Components/ProtectedRouteSection/myToken/MyTokens"));
const DepositList = lazy(() => import("../Components/ProtectedRouteSection/deposit/depositList/depositList"));
const KycUnderReview = lazy(() => import("../Components/ProtectedRouteSection/underReview/KycUnderReview"));
const InvestorPartnerSection = lazy(() => import("../Components/partner/ourpartner"));
const PartnerSelection = lazy(() => import("../Components/partner/partnerSelection"));
const UnlockWithdrawalPolicy = lazy(() => import("../Components/Footer/withdrawlPolicyPage"));
const NewsDetail = lazy(() => import("../Components/Homepage/newsDetail"));
const BlogDetail = lazy(() => import("../Components/Homepage/blogDetail"));
const AllBlogCards = lazy(() => import("../Components/Homepage/AllBlog"));
const AllSimilarNews = lazy(() => import("../Components/Homepage/AllNews"));
const VerifyAgent = lazy(() => import("../Components/Homepage/VerifyAgent"));

const withSuspense = (node) => (
  <Suspense fallback={<div style={{ minHeight: "60vh" }} />}>{node}</Suspense>
);


const PublicWrapper = () => {
  const isAuthenticated = !!localStorage.getItem("a13b_c9z_uid");
  const kycStats = JSON.parse(localStorage.getItem("bingold"));

  if (isAuthenticated) {
    if (kycStats?.data?.account_verify === null) {
      return <Navigate to="/user-kyc" replace />;
    }
    if (kycStats?.data?.account_verify === "Under review") {
      return <Navigate to="/under-review" replace />;
    }
    return <Navigate to="/Token" replace />;
  }
   return <Outlet />;
};


const ProtectedWrapper = () => {
  const isAuthenticated = !!localStorage.getItem("a13b_c9z_uid");
  const kycStats = JSON.parse(localStorage.getItem("bingold"));
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }


  const accountVerifyStatus = kycStats?.data?.account_verify;
  const isKycIncomplete = accountVerifyStatus === null;
  const isKycUnderReview = accountVerifyStatus === "Under review";
  const isOnKycPage = location.pathname.startsWith("/user-kyc");
  const isOnReviewPage = location.pathname === "/under-review";

  // ✅ Redirect if KYC is not submitted
  if (isKycIncomplete && !isOnKycPage) {
    return <Navigate to="/user-kyc" replace />;
  }

  // ✅ Redirect if KYC is under review
  if (isKycUnderReview && !isOnReviewPage) {
    return <Navigate to="/under-review" replace />;
  }

  // ✅ Prevent navigating to KYC if already approved
  if (!isKycIncomplete && !isKycUnderReview && isOnKycPage) {
    return <Navigate to="/Token" replace />;
  }

  return <Outlet />;
};

// 🌐 Router Configuration
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        element: <PublicWrapper />,
        children: [
          { path: "", element: <Home /> },
          { path: "/our-partner", element: withSuspense(<InvestorPartnerSection />) },
          { path: "/withdrawal-policy", element: withSuspense(<UnlockWithdrawalPolicy />) },
          { path: "/broker-type", element: withSuspense(<PartnerSelection />) },
          { path: "login", element: withSuspense(<Login />) },
          { path: "/signup", element: withSuspense(<Signup />) },
          { path: "/news/:slug", element: withSuspense(<NewsDetail />) },
          { path: "/blog/:slug", element: withSuspense(<BlogDetail />) },
          { path: "/blogs", element: withSuspense(<AllBlogCards />) },
          { path: "/news", element: withSuspense(<AllSimilarNews />) },
          { path: "/verify/:code", element: withSuspense(<VerifyAgent />) },
        ],
      },
      {
        element: <ProtectedWrapper />,
        children: [
          { path: "Token", element: withSuspense(<Token />) },
          { path: "user-kyc", element: withSuspense(<Kyc />) },
          { path: "user-kyc/manual-kyc", element: withSuspense(<Manuwalkyc />) },
          { path: "user-kyc/online-kyc", element: withSuspense(<SumsubKyc />) },
          { path: "profile", element: withSuspense(<Profile />) },
          { path: "deposit", element: withSuspense(<Deposit />) },
          { path: "my-token", element: withSuspense(<MyTokens />) },
          { path: "under-review", element: withSuspense(<KycUnderReview />) },
          { path: "deposit-history", element: withSuspense(<DepositList />) },
        ],
      },
      {
        path: "*",
        element: <div>404 - Page Not Found</div>,
      },
    ],
  },
]);

export default router;
